<div class="radio-checkbox-tile"
    [ngClass]="{
        'radio-checkbox-tile--checkbox-mode': checkboxMode,
        'radio-checkbox-tile--with-error': errorVisible,
        'radio-checkbox-tile--single-option': isSingleOption
    }">

    <div *ngIf="fieldConfig.caption"
         class="radio-checkbox-tile__caption">
        {{ fieldConfig.caption | translate }}
    </div>

    <mat-radio-group
            class="radio-checkbox-tile__tiles"
            matRadioGroup
            id="{{fieldConfig.fieldKey}}"
            (change)="onChange($event)"
            (click)="onClick($event)"
            [formControl]="control">
      <mat-radio-button *ngFor="let config of fieldConfig.radioConfig; let i = index"
                        class="radio-checkbox-tile__tile"
                        [disabled]="config.disabled"
                        id="{{fieldConfig.fieldKey + '-' + config.value}}"
                        [value]="config.value">
          <div class="radio-checkbox-tile__content-wrapper">
              <div *ngIf="checkboxMode"
                   class="radio-checkbox-tile__checkbox">
                  <mat-checkbox [checked]="true" [disabled]="true"></mat-checkbox>
              </div>
              <div class="radio-checkbox-tile__content">
                  <ng-container *ngTemplateOutlet="content; context: {data: contentData[i]}"></ng-container>
              </div>
          </div>

      </mat-radio-button>

    </mat-radio-group>

    <mat-error *ngIf="errorVisible" class="radio-error">{{ (context + '.' +
        fieldConfig.fieldKey + '.' +
        errorsMap.get(fieldConfig.fieldKey))|translate}}
    </mat-error>


</div>
